/**
 * Observer: ao sair do campo de validade (blur), alerta se a data estiver vencida.
 * Usado na Conferência de Entrada (inputs-inventory).
 */
import { notify } from '../../versa/msgbox.js';

/** Interpreta yyyy-mm-dd, dd-mm-yyyy ou dd/mm/yyyy como data local. */
function parseLocalDate(value) {
	if (value == null || value === '') return null;
	const s = String(value).trim();
	let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
	if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
	m = s.match(/^(\d{2})-(\d{2})-(\d{4})/);
	if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
	m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
	if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
	return null;
}

function todayLocal() {
	const n = new Date();
	return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}

function formatBr(d) {
	const dd = String(d.getDate()).padStart(2, '0');
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	return `${dd}/${mm}/${d.getFullYear()}`;
}

function paintExpired(node, expired) {
	if (!node) return;
	if (expired) {
		node.style.borderColor = '#c00';
		node.style.backgroundColor = '#fff5f5';
	} else {
		node.style.removeProperty('border-color');
		node.style.removeProperty('background-color');
	}
}

export default function () {
	return {
		events: ['blur'],
		async handleEvents(ev) {
			if (ev.type !== 'blur') return;
			const node = document.querySelector(this.selector);
			if (!node) return;

			const field = this.form?.getFieldBySelector?.(this.selector);
			if (field) {
				field.setValue(node.value);
				field.refresh?.();
			}

			const raw = field?.getValue?.() ?? node.value;
			const exp = parseLocalDate(raw);
			if (!exp) {
				paintExpired(node, false);
				return;
			}

			const expired = exp < todayLocal();
			paintExpired(node, expired);
			if (expired) {
				notify(
					`Atenção: a data de validade informada (${formatBr(exp)}) está vencida. Confira o produto antes de continuar a conferência.`,
					'Conferência de Entrada'
				);
			}
		},
	};
}
